<script>
import AuthTemplate from "../../components/AuthTemplate.vue";

import { mapActions } from "vuex";
import TelInputAuth from "../../components/TelInput/TelInputAuth.vue";

export default {
  name: "SignUp",

  components: { AuthTemplate, TelInputAuth },

  data: () => ({
    phone: null,

    isLoading: false,
  }),

  created() {
    const phone = this.$route.query.phone;

    if (Number(phone)) {
      this.phone = phone;
    }
  },

  methods: {
    ...mapActions("auth", ["FORGOT_PASSWORD"]),

    onSend() {
      if (this.$refs.form.validate()) {
        const phone = this.phone;

        this.FORGOT_PASSWORD({ phone }).then((status) => {
          if (status != null) {
            this.$store.dispatch("SET_SNACKBAR", {
              text: this.$t("password_on_sms"),
              color: "success",
            });
            this.$router.push(`/?phone=${this.phone}`);
          }
        });
      }
    },
  },
};
</script>

<template>
  <auth-template :title="$t(`Restore password`)">
    <v-form @submit.prevent="() => false" ref="form" lazy-validation>
      <tel-input-auth @enter="onSend" v-model="phone" required autofocus />
    </v-form>

    <div class="-actions">
      <div style="flex: 1">
        <v-btn
          :to="`/?phone=${phone}`"
          class="transform-none w-100"
          outlined
          dark
        >
          {{ $t("Enter") }}
        </v-btn>
      </div>
      <div class="d-block pt-4 px-2" />
      <div style="flex: 1">
        <v-btn
          :loading="isLoading"
          @click="onSend"
          class="transform-none w-100"
          outlined
          dark
        >
          {{ $t("Restore password") }}
          <v-icon right> mdi-chevron-right </v-icon>
        </v-btn>
      </div>
    </div>
  </auth-template>
</template>

<style lang="scss" scoped>
.-actions {
  display: flex;

  @media only screen and(max-width:599px) {
    flex-direction: column-reverse;
  }
}
</style>
